import { useTranslation } from 'react-i18next'
import { Gift, Sparkles } from 'lucide-react'
import TopbarAction from '@/components/TopbarAction'
import { useAppStore } from '@/stores/useAppStore'
import { useReleaseNotes } from './use-release-notes'

/** Topbar button; the release notes open in the docked side panel. */
const WhatsNewButton = () => {
    const { t } = useTranslation('release-notes')
    const sidePanel = useAppStore((state) => state.sidePanel)
    const toggleSidePanel = useAppStore((state) => state.toggleSidePanel)
    const { notes, unreadCount } = useReleaseNotes()

    if (notes.length === 0) return null

    const hasUnread = unreadCount > 0
    const label = hasUnread
        ? t('whats-new.unread-count', { count: unreadCount })
        : t('whats-new.title')

    return (
        <TopbarAction
            icon={hasUnread ? Gift : Sparkles}
            aria-label={label}
            aria-pressed={sidePanel === 'whats-new'}
            onClick={() => toggleSidePanel('whats-new')}
            // Below md the topbar cluster leaves no room for the page trail;
            // the account menu carries the same entry (AccountDropdown).
            className="max-md:hidden"
            tone={hasUnread ? 'primary' : 'default'}
            badge={{ count: unreadCount, tone: 'primary' }}
        />
    )
}

export default WhatsNewButton
